module.exports = __webpack_public_path__ + "b7b0993308db464c5462aa261a338140.otf";